import React, { useState, useEffect } from "react";
import { Col, Row } from "antd";

import ArticlesGridContainer from "../../Shared/ArticlesGridContainer";
import ArticlesHybridContainer from "../../Shared/ArticlesHybridContainer";
import ArticlesHybridMirrorContainer from "../../Shared/ArticlesHybridMirrorContainer";
import ArticlesListContainer from "../../Shared/ArticlesListContainer";
import { mapNewsArticlesList } from "../../../../utils";
import { INewArticlesItem } from "../interface";

interface IMyAccountsArticlesProps {
  articles: INewArticlesItem[];
  isListView: boolean;
  inEditionSmartSourced?: boolean;
  isCampaign?: boolean;
}

const MyAccountsArticles = (props: IMyAccountsArticlesProps) => {
  const { articles, isListView, inEditionSmartSourced, isCampaign } = props;
  // 21 articles are shown in the following order
  const articleSequence = [2, 3, 4, 4, 8];
  const [articleLists, setArticleLists] = useState<Array<Array<INewArticlesItem>>>([]);

  const updateArticlesLists = () => {
    let tmpArticleLists = mapNewsArticlesList(articles, articleSequence);
    setArticleLists(tmpArticleLists);
  };

  useEffect(() => {
    updateArticlesLists();
  }, [articles]);
  return (
    <>
      {isListView ? (
        <ArticlesListContainer
          isCampaign={isCampaign}
          inEditionSmartSourced={inEditionSmartSourced}
          articles={articles}
        />
      ) : (
        <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 24 }}>
          {/* 1st row */}
          <Col className="gutter-row" span={24}>
            {typeof articleLists[0] !== "undefined" && (
              <div className="padding-top-md padding-bottom-md">
                <ArticlesGridContainer
                  isCampaign={isCampaign}
                  key="accounts_news_row_1"
                  articles={articleLists[0]}
                  imgHeight="230"
                  imgWidth="613"
                  articleSpan={12}
                  inEditionSmartSourced={inEditionSmartSourced}
                />
              </div>
            )}
          </Col>

          <Col className="gutter-row" span={24}>
            {/* 2nd row */}
            {typeof articleLists[1] !== "undefined" && (
              <div className="padding-top-md padding-bottom-md">
                <ArticlesGridContainer
                  isCampaign={isCampaign}
                  key="accounts_news_row_2"
                  smallBlog
                  articles={articleLists[1]}
                  imgHeight="170"
                  imgWidth="401"
                  articleSpan={8}
                  inEditionSmartSourced={inEditionSmartSourced}
                />
              </div>
            )}
          </Col>

          <Col className="gutter-row" span={24}>
            {/* 3rd row   */}
            {typeof articleLists[2] !== "undefined" && (
              <div className="padding-top-md padding-bottom-md">
                <ArticlesHybridContainer
                  isCampaign={isCampaign}
                  inEditionSmartSourced={inEditionSmartSourced}
                  articles={articleLists[2]}
                />
              </div>
            )}
          </Col>

          <Col className="gutter-row" span={24}>
            {/* 4th row   */}
            {typeof articleLists[3] !== "undefined" && (
              <ArticlesHybridMirrorContainer
                isCampaign={isCampaign}
                inEditionSmartSourced={inEditionSmartSourced}
                articles={articleLists[3]}
              />
            )}
          </Col>

          {/* 5th row   */}
          <Col className="gutter-row" span={24}>
            {typeof articleLists[4] !== "undefined" && (
              <div className="padding-top-sm padding-bottom-sm list-style">
                <ArticlesListContainer
                  isCampaign={isCampaign}
                  inEditionSmartSourced={inEditionSmartSourced}
                  articles={articleLists[4]}
                />
              </div>
            )}
          </Col>
        </Row>
      )}
    </>
  );
};

export default MyAccountsArticles;
